import React, {
  Component,
  // DetailedHTMLProps
} from 'react';
import { withTheme } from 'styled-components';
import * as logger from '../../utils/logger';

class TrackImage extends Component<any> {
  start_time: number = Date.now();
  componentWillReceiveProps = (nextProps: any) => {
    // 图片发生变化，重置初始时间
    if (this.props.src !== nextProps.src) {
      this.start_time = Date.now();
    }
  };
  trackLoad = async (e: any, err: boolean, index?: number) => {
    const {
      challenge_mode,
      challenge_id,
      challenge_code,
      scheduleStatus,
      src,
    } = this.props;
    const duration = Date.now() - this.start_time;
    // src为空 会导致触发一onError，忽略该事件上报
    if (src !== '') {
      const result = this.props.src.match(/\/\/(.+?)\//);
      if (err) {
        this.props.onError && this.props.onError();
      } else {
        this.props.onLoad && this.props.onLoad('loadQuestionSuccess');
      }
    }
  };
  render() {
    const { getRef, theme, loadQuestionFailed, ...restProps } = this.props;
    return (
      <>
        {this.props.src && (
          <img
            id="captcha-verify-image"
            draggable={false}
            css={`
              ${loadQuestionFailed ? 'display: none;' : ''}
              user-drag: none;
              -webkit-user-drag: none;
              border-radius: ${theme.imgBorderRadius};
            `}
            {...restProps}
            onLoad={(e) => this.trackLoad(e, false)}
            onError={(e) => this.trackLoad(e, true)}
            ref={this.props.getRef}
          />
        )}
      </>
    );
  }
}

export default withTheme(TrackImage);
